<template>
    <div>
        <div class="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true">
            <div class="navbar-header">
                <ul class="nav navbar-nav flex-row">
                    <li class="nav-item mr-auto"><a class="navbar-brand" href="/">
                        <div class="brand-logo"><img class="logo" src="@/app-assets/images/brand/pacto-logo.png" alt="Pacto Logo" /></div>
                        </a></li>
                    <li class="nav-item nav-toggle"><a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse"><em class="bx bx-x d-block d-xl-none font-medium-4 primary"></em><em class="toggle-icon bx bx-disc font-medium-4 d-none d-xl-block primary" data-ticon="bx-disc"></em></a></li>
                </ul>
            </div>
            <div class="shadow-bottom"></div>
            <div class="main-menu-content">
                <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation" data-icon-style="lines">
                    <li class="nav-item nav-item-sidebar" id="dashboardItem">
                        <router-link :to="{name: 'DashboardPage' }">
                            <em class="menu-livicon" data-icon="desktop"></em><span class="menu-title" data-i18n="Dashboard">Dashboard</span>
                        </router-link>
                    </li>

                    <li class="navigation-header"><span>Users</span></li>
                    <li class="nav-item nav-item-sidebar" id="invitesItem">
                        <router-link :to="{name: 'InvitesPage' }">
                            <em class="menu-livicon" data-icon="envelope-pull"></em><span class="menu-title" data-i18n="Invites">Invites</span>
                        </router-link>
                    </li>
                    <li class="nav-item nav-item-sidebar">
                        <router-link :to="{name: 'TenantsPage' }">
                            <em class="menu-livicon" data-icon="users"></em><span class="menu-title" data-i18n="Tenants">Tenants</span>
                        </router-link>
                    </li>
                    <li class="nav-item nav-item-sidebar" id="landlordsItem">
                        <router-link :to="{name: 'LandlordsPage' }">
                            <em class="menu-livicon" data-icon="briefcase"></em><span class="menu-title" data-i18n="Property Owners">Property Owners</span>
                        </router-link>
                    </li>

                    <li class="navigation-header"><span>Properties</span></li>
                    <li class="nav-item nav-item-sidebar">
                        <router-link :to="{name: 'HousesPage' }">
                            <em class="menu-livicon" data-icon="home"></em><span class="menu-title" data-i18n="Properties">Properties</span>
                        </router-link>
                    </li>

                    <li class="navigation-header"><span>Contracts</span></li>
                    <li class="nav-item nav-item-sidebar" id="proposal-navbar-item">
                        <router-link :to="{name: 'ContractProposalsPage' }">
                            <em class="menu-livicon" data-icon="two-pointers"></em><span class="menu-title" data-i18n="Proposals">Proposals</span>
                        </router-link>
                    </li>
                    <li class="nav-item nav-item-sidebar" id="contracts-navbar-item">
                        <router-link :to="{name: 'ContractsPage' }">
                            <em class="menu-livicon" data-icon="pen"></em><span class="menu-title" data-i18n="Contracts">Contracts</span>
                        </router-link>
                    </li>

                    <li class="navigation-header"><span>Issues & Communications</span></li>
                    <li class="nav-item nav-item-sidebar">
                        <router-link :to="{name: 'IssuesPage' }">
                            <em class="menu-livicon" data-icon="legal"></em><span class="menu-title" data-i18n="Issues">Issues</span>
                        </router-link>
                    </li>
                    <li class="nav-item nav-item-sidebar">
                        <a href="https://forms.office.com/Pages/DesignPage.aspx?fragment=FormId%3DtNGGP2ssGkuyrm9elQvKHhm3Gnfi_H5AnEbe-r4OdINUNkJaRURTVUZYMklYUktPM0tNRUlTNlMwSy4u" target="_blank"  rel="noopener">
                            <em class="menu-livicon" data-icon="help"></em><span class="menu-title" data-i18n="Support Requests">Support Requests</span>
                        </a>
                    </li>
                    <li class="nav-item nav-item-sidebar">
                        <a href="https://forms.office.com/Pages/DesignPage.aspx?fragment=FormId%3DtNGGP2ssGkuyrm9elQvKHhm3Gnfi_H5AnEbe-r4OdINUQ0xGMjkwWElDWUw4SjQyNVI5QUhNRFdPNS4u" target="_blank"  rel="noopener">
                            <em class="menu-livicon" data-icon="link"></em><span class="menu-title" data-i18n="Pacto Feedback - 1">Pacto Feedback - 1</span>
                        </a>
                    </li>
                    <li class="nav-item nav-item-sidebar">
                        <a href="">
                            <em class="menu-livicon" data-icon="link"></em><span class="menu-title" data-i18n="Pacto Feedback - 2">Pacto Feedback - 2</span>
                        </a>
                    </li>

                    <li class="navigation-header"><span>Settings</span></li>
                    <li class="nav-item nav-item-sidebar" id="nav-item-sidebar-profile">
                        <router-link :to="{name: 'ProfilePage' }">
                            <em class="menu-livicon" data-icon="user"></em><span class="menu-title" data-i18n="Profile">Profile</span>
                        </router-link>
                    </li>
                    <li class="nav-item nav-item-sidebar">
                        <router-link :to="{name: 'AdminsPage' }">
                            <em class="menu-livicon" data-icon="balance"></em><span class="menu-title" data-i18n="Admins">Users</span>
                        </router-link>
                    </li>
                    <li class="nav-item nav-item-sidebar">
                        <router-link :to="{name: 'ContractTemplatesPage' }">
                            <em class="menu-livicon" data-icon="notebook"></em><span class="menu-title" data-i18n="Contract Templates">Contract Templates</span>
                        </router-link>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Sidebar',
        mounted(){
            this.navigation()
        },

        methods: {
            navigation(){

                /** Handle Details Pages */
                const uri = location.href;

                if(uri.includes('contracts/proposals/')) {
                    $('#proposal-navbar-item').addClass('active');
                } else if(uri.includes('contracts/details/')) {
                    $('#contracts-navbar-item').addClass('active');
                }

                /** Handle Page Refresh */
                $("li.nav-item-sidebar > a").each(function(){
                    if($(this).hasClass("active")){
                        $(this).parents("li.nav-item-sidebar").addClass("active")
                    }
                })
                /** Active State */
                $("li.nav-item-sidebar").on("click", function(){
                    let $targetIcon = $(this).find(".menu-livicon")
                    $("li.nav-item-sidebar").removeClass("active-collapse")
                    $("li.nav-item-sidebar").removeClass("active")
                    $("li.nav-item-sidebar .menu-livicon").not($targetIcon).updateLiviconEvo({
                        strokeColor: '#8494a7',
                        solidColor: menuActiveIconColorsObj.iconSolidColor,
                        fillColor: menuActiveIconColorsObj.iconFillColor,
                        strokeColorAlt: menuActiveIconColorsObj.iconStrokeColorAlt
                    })
                    $(this).addClass("active")
                    $targetIcon.updateLiviconEvo({
                        strokeColor: '#4A0A1E',
                        solidColor: menuActiveIconColorsObj.iconSolidColor,
                        fillColor: menuActiveIconColorsObj.iconFillColor,
                        strokeColorAlt: menuActiveIconColorsObj.iconStrokeColorAlt
                    })
                })
            }
        }
    }
</script>
